import { ReactElement, useState, useEffect } from 'react'
import { ContextProps, createContext } from '../common/contextHelper'
import { useAuthContext } from './AuthContext'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
import { SensorProduct } from '../common/enums'

interface AppContextState {
  showLogo: boolean
  showDeviceListDrawer: boolean
  showCharts: boolean
  chartsToShow: string[]
  currentDate?: Date
  showSidebarNav: boolean
  showBatteryCharts: boolean
  setShowDeviceListDrawer: (show: boolean) => void
  toggleChartsToShow: () => void
  setCurrentDate: (date: Date) => void
  setShowCharts: (show: boolean) => void
  setShowSidebarNav: (show: boolean) => void
  setShowBatteryCharts: (show: boolean) => void
}

const [Provider, useAppContext] = createContext<AppContextState>(module.filename)

const SMALL_SCREEN_HEIGHT = 900

export { useAppContext }

const PRIMARY_CHART_LIST = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'C3']
const SECONDARY_CHART_LIST = [
  // 'Temperature',
  SensorProduct.Battery,
]

export function AppProvider({ children }: ContextProps): ReactElement {
  const { height } = useWindowDimensions()

  const { isAuthorized } = useAuthContext()

  const [showDeviceListDrawer, setShowDeviceListDrawer] = useState(false)
  const [showCharts, setShowCharts] = useState(false)
  const [chartsToShow, setChartsToShow] = useState(PRIMARY_CHART_LIST)
  const [currentDate, setCurrentDate] = useState<Date>()
  const [showSidebarNav, setShowSidebarNav] = useState(false)
  const [showBatteryCharts, setShowBatteryCharts] = useState(false)

  const showLogo = height > SMALL_SCREEN_HEIGHT || !isAuthorized

  useEffect(() => {
    if (showSidebarNav) {
      setShowDeviceListDrawer(false)
    }
  }, [showSidebarNav])

  useEffect(() => {
    if (showDeviceListDrawer) {
      setShowSidebarNav(false)
    }
  }, [showDeviceListDrawer])

  function toggleChartsToShow() {
    setChartsToShow(chartsToShow === PRIMARY_CHART_LIST ? SECONDARY_CHART_LIST : PRIMARY_CHART_LIST)
  }

  return (
    <Provider
      value={{
        showLogo,
        showDeviceListDrawer,
        chartsToShow,
        currentDate,
        showCharts,
        showSidebarNav,
        showBatteryCharts,
        setShowDeviceListDrawer,
        toggleChartsToShow,
        setCurrentDate,
        setShowCharts,
        setShowSidebarNav,
        setShowBatteryCharts,
      }}
    >
      {children}
    </Provider>
  )
}
